import CompanionSlideBatch from './companionSlideBatch'

const companionSlideBatch = new CompanionSlideBatch()
companionSlideBatch.init()
